import {availableCards} from "./availableCards";


const defaultLayout = {
    layoutName: 'default',
    cards: [
        availableCards.Main,
        [
            availableCards.Internal,
            {...availableCards.TabsCard, tabs: [
                    availableCards.Transactions,
                    availableCards.InyettDetails,
                    availableCards.CustomerConnections,
                    availableCards.CustomerInteractions,
                    availableCards.AoCustomerInfo,
                    availableCards.Migrations
                ]
            }
        ],
        availableCards.Subscriptions,
        availableCards.Usage,
        availableCards.Vbproducts,
        availableCards.ThirdPartyProducts
    ]
}

const smbLayout = {
    layoutName: 'smb',
    cards: [
        availableCards.Main,
        [
            availableCards.Internal,
            {...availableCards.TabsCard, tabs: [
                    availableCards.CustomerConnections,
                    availableCards.Transactions,
                    availableCards.InyettDetails,
                    availableCards.CustomerInteractions,
                    availableCards.AoCustomerInfo,
                    availableCards.Migrations
                ]
            }
        ],
        availableCards.Subscriptions,
        availableCards.Usage,
        availableCards.Vbproducts,
        availableCards.ThirdPartyProducts
    ]
}

const agreementsLayout = {
    layoutName: 'agreements',
    cards:
        [
            availableCards.Transactions,
            availableCards.Subscriptions,
            availableCards.Usage,
            availableCards.Vbproducts,
            availableCards.ThirdPartyProducts,
        ]
}

export const availableLayouts = {
    default: defaultLayout,
    smb: smbLayout,
    agreements: agreementsLayout,
    // Team-specific layouts
    9196: smbLayout,
    9583: smbLayout
};